import type { RootState } from '../../store';
import { createSelector } from '@reduxjs/toolkit';

const slice = (state: RootState) => state.reference;

// Section list
export const roadSectionsQuery = createSelector(slice, (state) => state.roadSections);
export const loadingRoadSectionsQuery = createSelector(slice, (state) => state.resetRoadSectionsOngoing);

// Selection
export const selectedRoadSectionsQuery = createSelector(slice, (state) =>
    state.roadSections.filter((roadSection) => state.selectedRoadSectionIds.includes(roadSection.id)),
);
export const selectedRoadSectionIdsQuery = (state) =>
    selectedRoadSectionsQuery(state).map((roadSection) => roadSection.id);

// Sorting
export const roadSectionsSortQuery = createSelector(slice, (state) => state.sort);

// Filtering
export const roadSectionsFilterQuery = createSelector(slice, (state) => state.filter);

// Pagination
export const roadSectionsPaginationQuery = createSelector(slice, (state) => state.pagination);

// Column visibility
export const roadSectionsColumnVisibilityQuery = createSelector(slice, (state) => state.columnVisibility);
